export default {
    'label.email.title': 'Title',
    'label.email.contnet': 'Contnet',
    'menu.rbac.email':'Email'

};
